export const subReasonsDescriptions = {
  withExchanges: 'Para este motivo, las causas concretas de cada reembolso o cambio.',
  withoutExchanges: 'Para este motivo, las causas concretas de cada reembolso.',
}
